module.exports = __webpack_public_path__ + "img/ch17_02_果茶误会_v2.06c0a907.png";